import { useLanguage } from './LanguageContext'
import { translations } from './translations'

/** Returns the translation dictionary for the active language. */
export function useT() {
  const { lang } = useLanguage()
  return translations[lang]
}
